module.exports = __webpack_public_path__ + "img/help-3.ca.6eda01fb.jpg";